module.exports = __webpack_public_path__ + "assets/b4.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b4.png
// module id = 627
// module chunks = 0